<template>
  <span class="shop-report-download">
    <el-button size="small" type="success" icon="el-icon-download" @click="visible = true">下载门店财务报表</el-button>
    <el-dialog title="下载当前门店财务报表" :visible.sync="visible" width="560px" append-to-body :close-on-click-modal="!loading">
      <p>沿用航天美甲工资原表，包含财务报表、统计数据来源、美甲工资、周绩效及所选月份明细。</p>
      <div class="report-range">
        <el-date-picker v-model="monthToAdd" type="month" value-format="yyyy-MM" placeholder="选择月份" :disabled="loading" style="width: 190px" />
        <el-button :disabled="loading || !monthToAdd" size="small" @click="addMonth">添加月份</el-button>
      </div>
      <div class="report-months"><el-tag v-for="month in months" :key="month" :closable="!loading" @close="removeMonth(month)">{{ month }}</el-tag></div>
      <p class="report-note">默认本月，可添加多个、不连续的月份。首页和周绩效对应所选月份。未保存工资按系统规则试算，已有工资保留财务调整值。</p>
      <span slot="footer">
        <el-button :disabled="loading" @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="download">{{ loading ? '正在生成报表' : '下载 Excel' }}</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ShopReportDownload',
  data () {
    const now = new Date()
    const current = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0')
    return { visible: false, loading: false, months: [current], monthToAdd: '' }
  },
  methods: {
    addMonth () {
      if (this.monthToAdd && this.months.indexOf(this.monthToAdd) === -1) this.months.push(this.monthToAdd)
      this.months.sort()
      this.monthToAdd = ''
    },
    removeMonth (month) { this.months = this.months.filter(value => value !== month) },
    async download () {
      if (this.loading) return
      this.addMonth()
      if (!this.months.length) {
        this.$message.warning('请至少选择一个月份')
        return
      }
      this.loading = true
      try {
        const response = await axios({
          method: 'post', url: '/api/shopReport/download', responseType: 'blob', timeout: 180000,
          headers: { 'Content-Type': 'application/json', token: localStorage.getItem('logintoken') },
          data: { months: this.months }
        })
        const type = response.headers['content-type'] || ''
        if (type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') === -1) {
          let message = '报表生成失败，请重新登录或稍后重试'
          try {
            const result = JSON.parse(await this.readBlob(response.data))
            message = result.message || result.msg || message
          } catch (ignored) { /* 非 JSON 错误不作为 Excel 下载 */ }
          throw new Error(message)
        }
        let filename = '当前门店_统一财务报表.xlsx'
        const disposition = response.headers['content-disposition'] || ''
        const match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
        if (match) filename = decodeURIComponent(match[1])
        const url = window.URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
        this.visible = false
        this.$message.success('已开始下载，请在浏览器下载列表中查看')
      } catch (error) {
        let message = error.message || '下载失败，请稍后重试'
        if (error.response && error.response.data instanceof Blob) {
          try { const result = JSON.parse(await this.readBlob(error.response.data)); message = result.message || result.msg || message } catch (ignored) { /* preserve network error */ }
        }
        if (error.code === 'ECONNABORTED' || (error.response && error.response.status === 504)) message = '报表生成超时，请稍后重试'
        this.$message.error(message)
      } finally {
        this.loading = false
      }
    },
    readBlob (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsText(blob)
      })
    }
  }
}
</script>

<style scoped>
.shop-report-download { margin-left: 10px; }
.report-range { display: flex; align-items: center; gap: 12px; margin-top: 22px; }
.report-months { margin-top: 12px; }
.report-months .el-tag { margin: 0 8px 8px 0; }
.report-note { color: #606266; line-height: 1.8; margin-top: 24px; }
</style>



// WEBPACK FOOTER //
// src/components/ShopReportDownload.vue